module.exports = __webpack_public_path__ + "assets/img/information_0.3f6557c3.svg";